import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBz9Skclgj6sAqf2Un8rcmgKbz7Wuoxw6I",
  authDomain: "personal-finance-sjn.firebaseapp.com",
  projectId: "personal-finance-sjn",
  storageBucket: "personal-finance-sjn.appspot.com",
  messagingSenderId: "745605896795",
  appId: "1:745605896795:web:ea09e80e38d8c41f8c7d7e",
  measurementId: "G-XWHZSL3QTT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
